import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import { formatGraphqlErrors } from 'utils/helpers';
import { AddLoanConsultantDocument, LoanConsultantsDocument } from 'graphql/generated/graphql';

const useAddLoadConsultant = () => {
  const [addLoanConsultantMutation] = useMutation(AddLoanConsultantDocument);

  const handleSubmit = useCallback(
    async (variables: { email: string; firstName: string; lastName: string }) => {
      try {
        await addLoanConsultantMutation({
          variables: { input: { ...variables } },
          refetchQueries: [{ query: LoanConsultantsDocument }],
          awaitRefetchQueries: true,
        });
      } catch (error) {
        throw formatGraphqlErrors(error);
      }
    },
    [addLoanConsultantMutation],
  );

  return handleSubmit;
};

export default useAddLoadConsultant;
